/*Slideshow ver 3*/
$(document).ready(function() {
  this.$container = $('.rb-ss-ver3');
  this.settings = {
    timechange 		: this.$container.data('slidespeed'),
    auto 			: this.$container.data('auto')
  }
  var $time = this.settings.timechange;
  var $auto = this.settings.auto;
    $('#rb-ss-ver3').nivoSlider({
        effect: 'random',
        animSpeed: 500,
        pauseOnHover: false,
        manualAdvance: $auto,
        pauseTime: $time
    });
    $('#rb-ss-ver3').on('swiperight',function(e){
        $('a.nivo-prevNav').trigger('click');
        e.stopPropagation();
        return false;
    });
    $('#rb-ss-ver3').on('swipeleft',function(e){
        $('a.nivo-nextNav').trigger('click');
        e.stopPropagation();
        return false;
    });
});